// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/TrackingKindSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/TrackingKindSortBy.proto.
 */
export const file_Enumerations_TrackingKindSortBy: GenFile = /*@__PURE__*/
  fileDesc("CiVFbnVtZXJhdGlvbnMvVHJhY2tpbmdLaW5kU29ydEJ5LnByb3RvEhp0aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucyqwAgoSVHJhY2tpbmdLaW5kU29ydEJ5EiUKIVRSQUNLSU5HX0tJTkRfU09SVF9CWV9VTlNQRUNJRklFRBAAEisKH1RSQUNLSU5HX0tJTkRfU09SVF9CWV9URU5BTlRfSUQQAxoGysfNDwEDEiYKGlRSQUNLSU5HX0tJTkRfU09SVF9CWV9OQU1FEAQaBsrHzQ8BBBItCiBUUkFDS0lOR19LSU5EX1NPUlRfQllfQ1JFQVRFRF9BVBBkGgfKx80PAmQBEi4KIVRSQUNLSU5HX0tJTkRfU09SVF9CWV9NT0RJRklFRF9BVBBlGgfKx80PAmQCEi0KIFRSQUNLSU5HX0tJTkRfU09SVF9CWV9ERUxFVEVEX0FUEGYaB8rHzQ8CZAMiBAgBEAEiBAgCEAIiBAgFEGNCKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw", [file_Options_EnumValueOptions]);

/**
 * Determines by which columns to sort tracking kinds (billable, etc.) by.
 *
 * @generated from enum time_tracking.enumerations.TrackingKindSortBy
 */
export enum TrackingKindSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: TRACKING_KIND_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the tracking kinds by their tenant id.
   *
   * @generated from enum value: TRACKING_KIND_SORT_BY_TENANT_ID = 3;
   */
  TENANT_ID = 3,

  /**
   * Sort the tracking kinds by their name.
   *
   * @generated from enum value: TRACKING_KIND_SORT_BY_NAME = 4;
   */
  NAME = 4,

  /**
   * Sort the tracking kinds by their creation time stamp.
   *
   * @generated from enum value: TRACKING_KIND_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the tracking kinds by their modification time stamp.
   *
   * @generated from enum value: TRACKING_KIND_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the tracking kinds by their deletion time stamp.
   *
   * @generated from enum value: TRACKING_KIND_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.TrackingKindSortBy.
 */
export const TrackingKindSortBySchema: GenEnum<TrackingKindSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_TrackingKindSortBy, 0);

